interface Parameter {
	callback?: (isIntersecting: boolean) => void;
	rootMargin?: string;
	threshold?: number | number[];
	once?: boolean;
}

export function intersectionObserver(node: HTMLElement, options?: Parameter): void {
	$effect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				const isIntersecting = entries[0].isIntersecting;

				if (options?.callback) {
					options.callback(isIntersecting);
				}

				if (options?.once && isIntersecting) {
					observer.disconnect();
				}
			},
			options ? { rootMargin: options.rootMargin, threshold: options.threshold } : undefined
		);

		observer.observe(node);

		return () => {
			observer.disconnect();
		};
	});
}
